import { INVALIDATE_DEPENSES } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import { GET_DEPENSES_API_ROUTE } from 'routes/api/endpoints';

const depenseApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getDepenses: build.query({
      query: ({ dossier_id }) =>
        `${GET_DEPENSES_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
      providesTags: [INVALIDATE_DEPENSES],
    }),
    getDepenseById: build.query({
      query: ({ dossier_id, id }) =>
        `${GET_DEPENSES_API_ROUTE}?dossier_id=${dossier_id}&id=${id}&page=1&page_size=100`,
      providesTags: [INVALIDATE_DEPENSES],
    }),
  }),
});

export const { useGetDepensesQuery, useGetDepenseByIdQuery } = depenseApi;
